import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import LinkPreviewCard from 'src/components/LinkPreviewCard/LinkPreviewCard';
import calcomCreateEventTypePreview from '../../assets/calcom-create-event-type-preview.png';
import './event-type-required-callout.scss';

const EventTypeRequiredCallout = () => {
  return (
    <div className="event-type-required-callout">
      <Callout
        variant="warning"
        title="Set up a Cal.com event type first"
        subtitle={
          <>
            Booking links point at a Cal.com event type for their availability,
            and Juniper can&apos;t create one for you yet — make one in Cal.com,
            then refresh this page to add booking links. Do this from a properly
            provisioned developer or employee account, so the event types behind
            your booking links stay under your team&apos;s control.
          </>
        }
      />
      <LinkPreviewCard
        href="https://cal.com/help/event-types/create-first-event"
        title="Create your first event type"
        description="Define the meeting length and availability your booking links will use."
        siteName="Cal.com Help"
        image={calcomCreateEventTypePreview}
      />
    </div>
  );
};

export default EventTypeRequiredCallout;